import React from "react";
import { Modal, message } from "antd";

export default function TechCardModal({
  formContext,
  width,
  children,
  title,
  isOpen,
  setOpen,
  handleSubmit,
  submitIsDisabled,
  changeData,
  setChangeData,
  loading = false,
  okText = "Подтвердить",
  cancelText = "Отмена",
  onCancel,
  destroyOnClose = false,
  maskClosable = true,
  isSuccessfullySaved = false,
}) {
  const handleOk = async () => {
    try {
      const values = await formContext.validateFields();
      await handleSubmit(values);
      if (setChangeData) setChangeData(false);
    } catch (error) {
      if (error.errorFields && error.errorFields.length > 0) {
        error.errorFields.forEach((err) => {
          message.error(`Ошибка в поле ${err.name.join(".")}: ${err.errors.join(", ")}`);
        });
      } else {
        message.error("Произошла ошибка при отправке формы");
      }
    }
  };

  const handleCancelInternal = (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    
    if (onCancel) {
      onCancel();
    } else {
      if (setChangeData) setChangeData(false);
      setOpen(false);
      formContext.resetFields();
    }
  };

  return (
    <Modal
      open={isOpen}
      width={width || 800}
      title={title}
      onOk={handleOk}
      okButtonProps={{
        disabled: submitIsDisabled,
        loading: loading,
      }}
      onCancel={handleCancelInternal}
      okText={okText}
      cancelText={cancelText}
      destroyOnClose={destroyOnClose}
      maskClosable={maskClosable}
      centered
      closeIcon={true}
      keyboard={true}
    >
      {children}
    </Modal>
  );
}